<template>
  <div class="myHeader clear">
    <div class="userName">
      <p @click="loginSub">
        {{userData.name}}
        <i class="el-icon-arrow-down"></i>
      </p>
      <div class="exitBox" v-if="loginType">
        <!-- <div class="exitlist" @click="accountSub">账户信息</div> -->
        <div class="exitlist" @click="LogOut">退出登录</div>
      </div>
    </div>
  </div>
  
</template>
<script>
  import { getUserDetail,logoutAdmin } from "@/assets/js/api";
  export default {
      name: 'myHeader',
      data() {
        return {
          userData:{},
          loginType:false,
          token:''
        };
      },
      props: {
        
      },
      mounted() {
        var data = localStorage.getItem('userData');
        this.token = JSON.parse(data).adminToken;
        this.getUser();
      },
      methods: {
        loginSub(){
          this.loginType = !this.loginType;
        },

        LogOut(){
          var that = this;
          logoutAdmin(this.token).then((res) => {
            var data = res;
            if(data.code == 200){
              that.$router.push('/');
              localStorage.removeItem('userData');
            } else {
              that.$message(data.msg);
            }
          });
        },

        async getUser(){
          var that = this;
          try {
            const response = await getUserDetail(this.token);
            if(response.code == 200){
              that.userData = response.data;
            } else { 
              that.$message(response.msg);
            }
          } catch (error) {
            console.log(error);
          }
        },

        accountSub(){
          this.$router.push('/account');
        }
      }
  }
</script>
<style scoped>
  .exitBox{
    background-color: #fff;
    position: absolute;
    top: 65px;
    right: -10px;
    padding: 10px 20px;
    width: 120px;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .5);
  }

  .exitBox .exitlist{
    font-size: 15px;
    color: #3d3d3d;
    line-height: 30px;
    cursor: pointer;
  }

  
</style>


// WEBPACK FOOTER //
// src/components/comment/myHeader.vue